import AddQcTask from './addQcTask.container';

export default AddQcTask;
